
  if (!customElements.get('unite-music')) {
    customElements.define('unite-music', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const panel = this.querySelector('.unite-music__panel');
        const toggle = this.querySelector('[data-toggle]');
        const off = this.querySelector('[data-off]');
        const host = this.querySelector('.unite-music__player');
        const select = this.querySelector('select');
        const link = this.querySelector('[data-playlist-link]');
        const create = () => {
          const frame = document.createElement('iframe');
          frame.src = 'https://open.spotify.com/embed/playlist/' + select.value + '?utm_source=generator&theme=0';
          frame.title = 'Playlist de Bandit en Spotify';
          frame.allow = 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
          frame.height = '152';
          host.replaceChildren(frame);
          link.href = 'https://open.spotify.com/playlist/' + select.value;
        };
        const minimize = () => {
          panel.classList.add('is-minimized');
          panel.inert = true;
          panel.setAttribute('aria-hidden','true');
          toggle.setAttribute('aria-expanded','false');
          toggle.textContent = '♫ Abrir música';
        };
        const open = () => {
          if (!host.querySelector('iframe')) create();
          panel.hidden = false;
          panel.classList.remove('is-minimized');
          panel.inert = false;
          panel.removeAttribute('aria-hidden');
          off.hidden = false;
          toggle.setAttribute('aria-expanded','true');
          toggle.textContent = 'Minimizar música −';
        };
        toggle.addEventListener('click', () => toggle.getAttribute('aria-expanded') === 'true' ? minimize() : open());
        this.querySelector('[data-minimize]').addEventListener('click', () => { minimize(); toggle.focus(); });
        off.addEventListener('click', () => {
          host.replaceChildren(); panel.hidden = true; panel.classList.remove('is-minimized'); off.hidden = true;
          toggle.setAttribute('aria-expanded','false'); toggle.textContent = '♫ Música'; toggle.focus();
        });
        select.addEventListener('change', create);
        this.onKey = event => { if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') { minimize(); toggle.focus(); } };
        document.addEventListener('keydown', this.onKey);
      }
      disconnectedCallback() { document.removeEventListener('keydown', this.onKey); }
    });
  }
